<template>
    <div
        class="page-container chat-visible"
        v-if="loggedIn"
        :class="{'sidebar-collapsed--chat' : sidebarStateRight, 'sidebar-collapsed' : sidebarStateLeft}"
    >
        <app-left-panel></app-left-panel>
        <app-profile-form></app-profile-form>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanel from '../chats/components/LeftPanel.vue';
    import ProfileForm from './ProfileForm.vue';

    export default {
        data: function () {
            return {
                //
            }
        },
        computed: {
            ...mapGetters([
                'loggedInHash',
                'loggedIn',
                'sidebarStateLeft',
                'sidebarStateRight'
            ]),
        },
        components: {
            appLeftPanel: LeftPanel,
            appProfileForm: ProfileForm,
        },
        beforeCreate() {
            //
        },
        watch: {
            loggedInHash: function (val) {
                if(!this.loggedIn){
                    this.$router.push({ name: 'login' });
                }
            },
        }
    }
</script>
